import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import { Popper, ClickAwayListener, IconButton } from '@mui/material';
import MoreOutlinedIcon from '@mui/icons-material/MoreOutlined';

function TagPicker({ insertTag, job }) {
  const [isOpen, setIsOpen] = useState(false);
  const anchor = useRef(null);

  const classes = useStyles();

  function handleClick(tag) {
    insertTag(tag);
    setIsOpen(false);
  }

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div>
        <IconButton
          classes={{ root: classes.actionButton }}
          ref={anchor}
          onClick={() => setIsOpen(!isOpen)}
        >
          <MoreOutlinedIcon fontSize="small" color="primary" />
        </IconButton>
        <Popper
          className={classes.popper}
          anchorEl={anchor.current}
          open={isOpen}
          placement="top-start"
        >
          <React.Fragment>
            <div
              className={classes.popperItem}
              onClick={() => handleClick('{{contact.firstName | default: "there"}}')}
            >
              <span>First Name</span>
            </div>
            <div
              className={classes.popperItem}
              onClick={() => handleClick('{{contact.lastName | default: "there"}}')}
            >
              <span>Last Name</span>
            </div>
            <div className={classes.popperItem} onClick={() => handleClick(job.title)}>
              <span>Job Name</span>
            </div>
            <div
              className={classes.popperItem}
              onClick={() => handleClick(job.address_state || job.location)}
            >
              <span>Job Location</span>
            </div>
          </React.Fragment>
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

TagPicker.propTypes = {
  insertTag: PropTypes.func.isRequired,
  job: PropTypes.object.isRequired
};

export default TagPicker;
